import React from "react";

const ReferralUsersList = React.lazy(() => import('src/pages/referral_management/ReferralUsersList'));
const ReferralUserDetail = React.lazy(() => import('src/pages/referral_management/ReferralUserDetail'));

const routes = [
    { path: '/dashboard/referral-users-list/:id', name: 'Referrer Detail', element: ReferralUserDetail },
    { path: '/dashboard/referral-users-list', name: 'Referrers', element: ReferralUsersList },
];

export default routes;
